import { ELanguage, TKeyboardKey, TKeyboardKeys, TKeyboardLanguage } from '../types';

const englishAllKeys: TKeyboardKeys = {
  row1: [
    { className: 'key--letter', code: 'Backquote', character: '&#96;' },
    { className: 'key--letter', code: 'Digit1', character: '&#49;' },
    { className: 'key--letter', code: 'Digit2', character: '&#50;' },
    { className: 'key--letter', code: 'Digit3', character: '&#51;' },
    { className: 'key--letter', code: 'Digit4', character: '&#52;' },
    { className: 'key--letter', code: 'Digit5', character: '&#53;' },
    { className: 'key--letter', code: 'Digit6', character: '&#54;' },
    { className: 'key--letter', code: 'Digit7', character: '&#55;' },
    { className: 'key--letter', code: 'Digit8', character: '&#56;' },
    { className: 'key--letter', code: 'Digit9', character: '&#57;' },
    { className: 'key--letter', code: 'Digit0', character: '&#48;' },
    { className: 'key--letter', code: 'Minus', character: '&#45;' },
    { className: 'key--letter', code: 'Equal', character: '&#61;' },
    {
      className: 'key--bottom-right key--word key--w2',
      code: 'Backspace',
      character: '<span>backspace</span>',
    },
  ],
  row2: [
    {
      className: 'key--bottom-left key--word key--w2',
      code: 'Tab',
      character: '<span>menu up</span>',
    },
    { className: 'key--letter', code: 'KeyQ', character: '&#81;' },
    { className: 'key--letter', code: 'KeyW', character: '&#87;' },
    { className: 'key--letter', code: 'KeyE', character: '&#69;' },
    { className: 'key--letter', code: 'KeyR', character: '&#82;' },
    { className: 'key--letter', code: 'KeyT', character: '&#84;' },
    { className: 'key--letter', code: 'KeyY', character: '&#89;' },
    { className: 'key--letter', code: 'KeyU', character: '&#85;' },
    { className: 'key--letter', code: 'KeyI', character: '&#73;' },
    { className: 'key--letter', code: 'KeyO', character: '&#79;' },
    { className: 'key--letter', code: 'KeyP', character: '&#80;' },
    { className: 'key--letter', code: 'BracketLeft', character: '&#91;' },
    { className: 'key--letter', code: 'BracketRight', character: '&#93;' },
    { className: 'key--letter', code: 'IntlBackslash', character: '&#92;' },
  ],
  row3: [
    {
      className: 'key--bottom-left key--word key--w3',
      code: 'CapsLock',
      character: '<span>caps lock</span>',
    },
    { className: 'key--letter', code: 'KeyA', character: '&#65;' },
    { className: 'key--letter', code: 'KeyS', character: '&#83;' },
    { className: 'key--letter', code: 'KeyD', character: '&#68;' },
    { className: 'key--letter', code: 'KeyF', character: '&#70;' },
    { className: 'key--letter', code: 'KeyG', character: '&#71;' },
    { className: 'key--letter', code: 'KeyH', character: '&#72;' },
    { className: 'key--letter', code: 'KeyJ', character: '&#74;' },
    { className: 'key--letter', code: 'KeyK', character: '&#75;' },
    { className: 'key--letter', code: 'KeyL', character: '&#76;' },
    { className: 'key--letter', code: 'Semicolon', character: '&#59;' },
    { className: 'key--letter', code: 'Quote', character: '&#39;' },
    {
      className: 'key--bottom-right key--word key--w3',
      code: 'Enter',
      character: '<span>return</span>',
    },
  ],
  row4: [
    {
      className: 'key--bottom-left key--word key--w4',
      code: 'ShiftLeft',
      character: '<span>shift</span>',
    },
    { className: 'key--letter', code: 'KeyZ', character: '&#90;' },
    { className: 'key--letter', code: 'KeyX', character: '&#88;' },
    { className: 'key--letter', code: 'KeyC', character: '&#67;' },
    { className: 'key--letter', code: 'KeyV', character: '&#86;' },
    { className: 'key--letter', code: 'KeyB', character: '&#66;' },
    { className: 'key--letter', code: 'KeyN', character: '&#78;' },
    { className: 'key--letter', code: 'KeyM', character: '&#77;' },
    { className: 'key--letter', code: 'Comma', character: '&#44;' },
    { className: 'key--letter', code: 'Period', character: '&#46;' },
    { className: 'key--letter', code: 'Slash', character: '&#47;' },
    {
      className: 'key--bottom-right key--word key--w4',
      code: 'ShiftRight',
      character: '<span>shift</span>',
    },
  ],
  row5: [
    {
      className: 'key--bottom-left key--word key--w1',
      code: 'ControlLeft',
      character: '<span>ctrl</span>',
    },
    { className: 'key--bottom-left key--word', code: 'X1', character: '<span>fn</span>' },
    { className: 'key--bottom-left key--word', code: 'X2', character: '<span>option</span>' },
    {
      className: 'key--bottom-left key--word key--w1',
      code: 'AltLeft',
      character: '<span>alt</span>',
    },
    { className: 'key--w5', code: 'Space', character: '&nbsp;' },
    {
      className: 'key--bottom-right key--word',
      code: 'AltRight',
      character: '<span>alt gr</span>',
    },
    {
      className: 'key--bottom-right key--word',
      code: 'ControlRight',
      character: '<span>ctrl</span>',
    },
    { className: 'key--arrow', code: 'Y1', character: '&nbsp;' },
    { className: 'key--arrow--tall', code: 'X3', character: '&nbsp;' },
    { className: 'key--arrow', code: 'Y2', character: '&nbsp;' },
  ],
};

const scandinavianRow2: TKeyboardKey[] = [
  {
    className: 'key--bottom-left key--word key--w2',
    code: 'Tab',
    character: '<span>menu up</span>',
  },
  { className: 'key--letter', code: 'KeyQ', character: '&#81;' },
  { className: 'key--letter', code: 'KeyW', character: '&#87;' },
  { className: 'key--letter', code: 'KeyE', character: '&#69;' },
  { className: 'key--letter', code: 'KeyR', character: '&#82;' },
  { className: 'key--letter', code: 'KeyT', character: '&#84;' },
  { className: 'key--letter', code: 'KeyY', character: '&#89;' },
  { className: 'key--letter', code: 'KeyU', character: '&#85;' },
  { className: 'key--letter', code: 'KeyI', character: '&#73;' },
  { className: 'key--letter', code: 'KeyO', character: '&#79;' },
  { className: 'key--letter', code: 'KeyP', character: '&#80;' },
  { className: 'key--letter', code: 'BracketLeft', character: '&#197;' },
  { className: 'key--letter', code: 'BracketRight', character: '&#168;' },
  { className: 'key--letter', code: 'IntlBackslash', character: '&#60;' },
];

const scandinavianRow3: TKeyboardKey[] = [
  {
    className: 'key--bottom-left key--word key--w3',
    code: 'CapsLock',
    character: '<span>caps lock</span>',
  },
  { className: 'key--letter', code: 'KeyA', character: '&#65;' },
  { className: 'key--letter', code: 'KeyS', character: '&#83;' },
  { className: 'key--letter', code: 'KeyD', character: '&#68;' },
  { className: 'key--letter', code: 'KeyF', character: '&#70;' },
  { className: 'key--letter', code: 'KeyG', character: '&#71;' },
  { className: 'key--letter', code: 'KeyH', character: '&#72;' },
  { className: 'key--letter', code: 'KeyJ', character: '&#74;' },
  { className: 'key--letter', code: 'KeyK', character: '&#75;' },
  { className: 'key--letter', code: 'KeyL', character: '&#76;' },
  { className: 'key--letter', code: 'Semicolon', character: '&#214;' },
  { className: 'key--letter', code: 'Quote', character: '&#196;' },
  {
    className: 'key--bottom-right key--word key--w3',
    code: 'Enter',
    character: '<span>return</span>',
  },
];

const scandinavianRow4: TKeyboardKey[] = [
  {
    className: 'key--bottom-left key--word key--w4',
    code: 'ShiftLeft',
    character: '<span>shift</span>',
  },
  { className: 'key--letter', code: 'KeyZ', character: '&#90;' },
  { className: 'key--letter', code: 'KeyX', character: '&#88;' },
  { className: 'key--letter', code: 'KeyC', character: '&#67;' },
  { className: 'key--letter', code: 'KeyV', character: '&#86;' },
  { className: 'key--letter', code: 'KeyB', character: '&#66;' },
  { className: 'key--letter', code: 'KeyN', character: '&#78;' },
  { className: 'key--letter', code: 'KeyM', character: '&#77;' },
  { className: 'key--letter', code: 'Comma', character: '&#44;' },
  { className: 'key--letter', code: 'Period', character: '&#46;' },
  { className: 'key--letter', code: 'Slash', character: '&#45;' },
  {
    className: 'key--bottom-right key--word key--w4',
    code: 'ShiftRight',
    character: '<span>shift</span>',
  },
];

const austroHungarianRow4: TKeyboardKey[] = [
  {
    className: 'key--bottom-left key--word key--w4',
    code: 'ShiftLeft',
    character: '<span>shift</span>',
  },
  { className: 'key--letter', code: 'KeyZ', character: '&#89;' },
  { className: 'key--letter', code: 'KeyX', character: '&#88;' },
  { className: 'key--letter', code: 'KeyC', character: '&#67;' },
  { className: 'key--letter', code: 'KeyV', character: '&#86;' },
  { className: 'key--letter', code: 'KeyB', character: '&#66;' },
  { className: 'key--letter', code: 'KeyN', character: '&#78;' },
  { className: 'key--letter', code: 'KeyM', character: '&#77;' },
  { className: 'key--letter', code: 'Comma', character: '&#44;' },
  { className: 'key--letter', code: 'Period', character: '&#46;' },
  { className: 'key--letter', code: 'Slash', character: '&#45;' },
  {
    className: 'key--bottom-right key--word key--w4',
    code: 'ShiftRight',
    character: '<span>shift</span>',
  },
];

export const keyboardLanguage: TKeyboardLanguage = {
  [ELanguage.English]: englishAllKeys,
  [ELanguage.Swedish]: {
    row1: [
      { className: 'key--letter', code: 'Backquote', character: '&#167;' },
      { className: 'key--letter', code: 'Digit1', character: '&#49;' },
      { className: 'key--letter', code: 'Digit2', character: '&#50;' },
      { className: 'key--letter', code: 'Digit3', character: '&#51;' },
      { className: 'key--letter', code: 'Digit4', character: '&#52;' },
      { className: 'key--letter', code: 'Digit5', character: '&#53;' },
      { className: 'key--letter', code: 'Digit6', character: '&#54;' },
      { className: 'key--letter', code: 'Digit7', character: '&#55;' },
      { className: 'key--letter', code: 'Digit8', character: '&#56;' },
      { className: 'key--letter', code: 'Digit9', character: '&#57;' },
      { className: 'key--letter', code: 'Digit0', character: '&#48;' },
      { className: 'key--letter', code: 'Minus', character: '&#43;' },
      { className: 'key--letter', code: 'Equal', character: '&#96;' },
      {
        className: 'key--bottom-right key--word key--w2',
        code: 'Backspace',
        character: '<span>backspace</span>',
      },
    ],
    row2: scandinavianRow2,
    row3: scandinavianRow3,
    row4: scandinavianRow4,
    row5: [
      {
        className: 'key--bottom-left key--word key--w1',
        code: 'ControlLeft',
        character: '<span>ctrl</span>',
      },
      { className: 'key--bottom-left key--word', code: 'X1', character: '<span>fn</span>' },
      { className: 'key--bottom-left key--word', code: 'X2', character: '<span>option</span>' },
      {
        className: 'key--bottom-left key--word key--w1',
        code: 'AltLeft',
        character: '<span>alt</span>',
      },
      { className: 'key--w5', code: 'Space', character: '&nbsp;' },
      {
        className: 'key--bottom-right key--word',
        code: 'AltRight',
        character: '<span>alt gr</span>',
      },
      {
        className: 'key--bottom-right key--word',
        code: 'ControlRight',
        character: '<span>ctrl</span>',
      },
      { className: 'key--arrow', code: 'Y1', character: '&nbsp;' },
      { className: 'key--arrow--tall', code: 'X3', character: '&nbsp;' },
      { className: 'key--arrow', code: 'Y2', character: '&nbsp;' },
    ],
  },
  [ELanguage.Norwegian]: {
    row1: [
      { className: 'key--letter', code: 'Backquote', character: '&#124;' },
      { className: 'key--letter', code: 'Digit1', character: '&#49;' },
      { className: 'key--letter', code: 'Digit2', character: '&#50;' },
      { className: 'key--letter', code: 'Digit3', character: '&#51;' },
      { className: 'key--letter', code: 'Digit4', character: '&#52;' },
      { className: 'key--letter', code: 'Digit5', character: '&#53;' },
      { className: 'key--letter', code: 'Digit6', character: '&#54;' },
      { className: 'key--letter', code: 'Digit7', character: '&#55;' },
      { className: 'key--letter', code: 'Digit8', character: '&#56;' },
      { className: 'key--letter', code: 'Digit9', character: '&#57;' },
      { className: 'key--letter', code: 'Digit0', character: '&#48;' },
      { className: 'key--letter', code: 'Minus', character: '&#43;' },
      { className: 'key--letter', code: 'Equal', character: '&#92;' },
      {
        className: 'key--bottom-right key--word key--w2',
        code: 'Backspace',
        character: '<span>backspace</span>',
      },
    ],
    row2: scandinavianRow2,
    row3: [
      {
        className: 'key--bottom-left key--word key--w3',
        code: 'CapsLock',
        character: '<span>caps lock</span>',
      },
      { className: 'key--letter', code: 'KeyA', character: '&#65;' },
      { className: 'key--letter', code: 'KeyS', character: '&#83;' },
      { className: 'key--letter', code: 'KeyD', character: '&#68;' },
      { className: 'key--letter', code: 'KeyF', character: '&#70;' },
      { className: 'key--letter', code: 'KeyG', character: '&#71;' },
      { className: 'key--letter', code: 'KeyH', character: '&#72;' },
      { className: 'key--letter', code: 'KeyJ', character: '&#74;' },
      { className: 'key--letter', code: 'KeyK', character: '&#75;' },
      { className: 'key--letter', code: 'KeyL', character: '&#76;' },
      { className: 'key--letter', code: 'Semicolon', character: '&#216;' },
      { className: 'key--letter', code: 'Quote', character: '&#198;' },
      {
        className: 'key--bottom-right key--word key--w3',
        code: 'Enter',
        character: '<span>return</span>',
      },
    ],
    row4: scandinavianRow4,
    row5: [
      {
        className: 'key--bottom-left key--word key--w1',
        code: 'ControlLeft',
        character: '<span>ctrl</span>',
      },
      { className: 'key--bottom-left key--word', code: 'X1', character: '<span>fn</span>' },
      { className: 'key--bottom-left key--word', code: 'X2', character: '<span>option</span>' },
      {
        className: 'key--bottom-left key--word key--w1',
        code: 'AltLeft',
        character: '<span>alt</span>',
      },
      { className: 'key--w5', code: 'Space', character: '&nbsp;' },
      {
        className: 'key--bottom-right key--word',
        code: 'AltRight',
        character: '<span>alt gr</span>',
      },
      {
        className: 'key--bottom-right key--word',
        code: 'ControlRight',
        character: '<span>ctrl</span>',
      },
      { className: 'key--arrow', code: 'Y1', character: '&nbsp;' },
      { className: 'key--arrow--tall', code: 'X3', character: '&nbsp;' },
      { className: 'key--arrow', code: 'Y2', character: '&nbsp;' },
    ],
  },
  [ELanguage.Finnish]: {
    row1: [
      { className: 'key--letter', code: 'Backquote', character: '&#167;' },
      { className: 'key--letter', code: 'Digit1', character: '&#49;' },
      { className: 'key--letter', code: 'Digit2', character: '&#50;' },
      { className: 'key--letter', code: 'Digit3', character: '&#51;' },
      { className: 'key--letter', code: 'Digit4', character: '&#52;' },
      { className: 'key--letter', code: 'Digit5', character: '&#53;' },
      { className: 'key--letter', code: 'Digit6', character: '&#54;' },
      { className: 'key--letter', code: 'Digit7', character: '&#55;' },
      { className: 'key--letter', code: 'Digit8', character: '&#56;' },
      { className: 'key--letter', code: 'Digit9', character: '&#57;' },
      { className: 'key--letter', code: 'Digit0', character: '&#48;' },
      { className: 'key--letter', code: 'Minus', character: '&#43;' },
      { className: 'key--letter', code: 'Equal', character: '&#180;' },
      {
        className: 'key--bottom-right key--word key--w2',
        code: 'Backspace',
        character: '<span>backspace</span>',
      },
    ],
    row2: scandinavianRow2,
    row3: scandinavianRow3,
    row4: scandinavianRow4,
    row5: [
      {
        className: 'key--bottom-left key--word key--w1',
        code: 'ControlLeft',
        character: '<span>ctrl</span>',
      },
      { className: 'key--bottom-left key--word', code: 'X1', character: '<span>fn</span>' },
      { className: 'key--bottom-left key--word', code: 'X2', character: '<span>option</span>' },
      {
        className: 'key--bottom-left key--word key--w1',
        code: 'AltLeft',
        character: '<span>alt</span>',
      },
      { className: 'key--w5', code: 'Space', character: '&nbsp;' },
      {
        className: 'key--bottom-right key--word',
        code: 'AltRight',
        character: '<span>alt gr</span>',
      },
      {
        className: 'key--bottom-right key--word',
        code: 'ControlRight',
        character: '<span>ctrl</span>',
      },
      { className: 'key--arrow', code: 'Y1', character: '&nbsp;' },
      { className: 'key--arrow--tall', code: 'X3', character: '&nbsp;' },
      { className: 'key--arrow', code: 'Y2', character: '&nbsp;' },
    ],
  },
  [ELanguage.Hungarian]: {
    row1: [
      { className: 'key--letter', code: 'Backquote', character: '&#48;' },
      { className: 'key--letter', code: 'Digit1', character: '&#49;' },
      { className: 'key--letter', code: 'Digit2', character: '&#50;' },
      { className: 'key--letter', code: 'Digit3', character: '&#51;' },
      { className: 'key--letter', code: 'Digit4', character: '&#52;' },
      { className: 'key--letter', code: 'Digit5', character: '&#53;' },
      { className: 'key--letter', code: 'Digit6', character: '&#54;' },
      { className: 'key--letter', code: 'Digit7', character: '&#55;' },
      { className: 'key--letter', code: 'Digit8', character: '&#56;' },
      { className: 'key--letter', code: 'Digit9', character: '&#57;' },
      { className: 'key--letter', code: 'Digit0', character: '&#214;' },
      { className: 'key--letter', code: 'Minus', character: '&#220;' },
      { className: 'key--letter', code: 'Equal', character: '&#211;' },
      {
        className: 'key--bottom-right key--word key--w2',
        code: 'Backspace',
        character: '<span>backspace</span>',
      },
    ],
    row2: [
      {
        className: 'key--bottom-left key--word key--w2',
        code: 'Tab',
        character: '<span>menu up</span>',
      },
      { className: 'key--letter', code: 'KeyQ', character: '&#81;' },
      { className: 'key--letter', code: 'KeyW', character: '&#87;' },
      { className: 'key--letter', code: 'KeyE', character: '&#69;' },
      { className: 'key--letter', code: 'KeyR', character: '&#82;' },
      { className: 'key--letter', code: 'KeyT', character: '&#84;' },
      { className: 'key--letter', code: 'KeyY', character: '&#90;' },
      { className: 'key--letter', code: 'KeyU', character: '&#85;' },
      { className: 'key--letter', code: 'KeyI', character: '&#73;' },
      { className: 'key--letter', code: 'KeyO', character: '&#79;' },
      { className: 'key--letter', code: 'KeyP', character: '&#80;' },
      { className: 'key--letter', code: 'BracketLeft', character: '&#337;' },
      { className: 'key--letter', code: 'BracketRight', character: '&#218;' },
      { className: 'key--letter', code: 'IntlBackslash', character: '&#205;' },
    ],
    row3: [
      {
        className: 'key--bottom-left key--word key--w3',
        code: 'CapsLock',
        character: '<span>caps lock</span>',
      },
      { className: 'key--letter', code: 'KeyA', character: '&#65;' },
      { className: 'key--letter', code: 'KeyS', character: '&#83;' },
      { className: 'key--letter', code: 'KeyD', character: '&#68;' },
      { className: 'key--letter', code: 'KeyF', character: '&#70;' },
      { className: 'key--letter', code: 'KeyG', character: '&#71;' },
      { className: 'key--letter', code: 'KeyH', character: '&#72;' },
      { className: 'key--letter', code: 'KeyJ', character: '&#74;' },
      { className: 'key--letter', code: 'KeyK', character: '&#75;' },
      { className: 'key--letter', code: 'KeyL', character: '&#76;' },
      { className: 'key--letter', code: 'Semicolon', character: '&#201;' },
      { className: 'key--letter', code: 'Quote', character: '&#193;' },
      {
        className: 'key--bottom-right key--word key--w3',
        code: 'Enter',
        character: '<span>return</span>',
      },
    ],
    row4: austroHungarianRow4,
    row5: [
      {
        className: 'key--bottom-left key--word key--w1',
        code: 'ControlLeft',
        character: '<span>ctrl</span>',
      },
      { className: 'key--bottom-left key--word', code: 'X1', character: '<span>fn</span>' },
      { className: 'key--bottom-left key--word', code: 'X2', character: '<span>option</span>' },
      {
        className: 'key--bottom-left key--word key--w1',
        code: 'AltLeft',
        character: '<span>alt</span>',
      },
      { className: 'key--w5', code: 'Space', character: '&nbsp;' },
      {
        className: 'key--bottom-right key--word',
        code: 'AltRight',
        character: '<span>alt gr</span>',
      },
      {
        className: 'key--bottom-right key--word',
        code: 'ControlRight',
        character: '<span>ctrl</span>',
      },
      { className: 'key--arrow', code: 'Y1', character: '&nbsp;' },
      { className: 'key--arrow--tall', code: 'X3', character: '&nbsp;' },
      { className: 'key--arrow', code: 'Y2', character: '&nbsp;' },
    ],
  },
  [ELanguage.German]: {
    row1: [
      { className: 'key--letter', code: 'Backquote', character: '&#94;' },
      { className: 'key--letter', code: 'Digit1', character: '&#49;' },
      { className: 'key--letter', code: 'Digit2', character: '&#50;' },
      { className: 'key--letter', code: 'Digit3', character: '&#51;' },
      { className: 'key--letter', code: 'Digit4', character: '&#52;' },
      { className: 'key--letter', code: 'Digit5', character: '&#53;' },
      { className: 'key--letter', code: 'Digit6', character: '&#54;' },
      { className: 'key--letter', code: 'Digit7', character: '&#55;' },
      { className: 'key--letter', code: 'Digit8', character: '&#56;' },
      { className: 'key--letter', code: 'Digit9', character: '&#57;' },
      { className: 'key--letter', code: 'Digit0', character: '&#214;' },
      { className: 'key--letter', code: 'Minus', character: '&#223;' },
      { className: 'key--letter', code: 'Equal', character: '&#180;' },
      {
        className: 'key--bottom-right key--word key--w2',
        code: 'Backspace',
        character: '<span>backspace</span>',
      },
    ],
    row2: [
      {
        className: 'key--bottom-left key--word key--w2',
        code: 'Tab',
        character: '<span>menu up</span>',
      },
      { className: 'key--letter', code: 'KeyQ', character: '&#81;' },
      { className: 'key--letter', code: 'KeyW', character: '&#87;' },
      { className: 'key--letter', code: 'KeyE', character: '&#69;' },
      { className: 'key--letter', code: 'KeyR', character: '&#82;' },
      { className: 'key--letter', code: 'KeyT', character: '&#84;' },
      { className: 'key--letter', code: 'KeyY', character: '&#90;' },
      { className: 'key--letter', code: 'KeyU', character: '&#85;' },
      { className: 'key--letter', code: 'KeyI', character: '&#73;' },
      { className: 'key--letter', code: 'KeyO', character: '&#79;' },
      { className: 'key--letter', code: 'KeyP', character: '&#80;' },
      { className: 'key--letter', code: 'BracketLeft', character: '&#220;' },
      { className: 'key--letter', code: 'BracketRight', character: '&#43;' },
      { className: 'key--letter', code: 'IntlBackslash', character: '&#60;' },
    ],
    row3: scandinavianRow3,
    row4: austroHungarianRow4,
    row5: [
      {
        className: 'key--bottom-left key--word key--w1',
        code: 'ControlLeft',
        character: '<span>ctrl</span>',
      },
      { className: 'key--bottom-left key--word', code: 'X1', character: '<span>fn</span>' },
      { className: 'key--bottom-left key--word', code: 'X2', character: '<span>option</span>' },
      {
        className: 'key--bottom-left key--word key--w1',
        code: 'AltLeft',
        character: '<span>alt</span>',
      },
      { className: 'key--w5', code: 'Space', character: '&nbsp;' },
      {
        className: 'key--bottom-right key--word',
        code: 'AltRight',
        character: '<span>alt gr</span>',
      },
      {
        className: 'key--bottom-right key--word',
        code: 'ControlRight',
        character: '<span>ctrl</span>',
      },
      { className: 'key--arrow', code: 'Y1', character: '&nbsp;' },
      { className: 'key--arrow--tall', code: 'X3', character: '&nbsp;' },
      { className: 'key--arrow', code: 'Y2', character: '&nbsp;' },
    ],
  },
  [ELanguage.Dutch]: {
    row1: [
      { className: 'key--letter', code: 'Backquote', character: '&#64;' },
      { className: 'key--letter', code: 'Digit1', character: '&#49;' },
      { className: 'key--letter', code: 'Digit2', character: '&#50;' },
      { className: 'key--letter', code: 'Digit3', character: '&#51;' },
      { className: 'key--letter', code: 'Digit4', character: '&#52;' },
      { className: 'key--letter', code: 'Digit5', character: '&#53;' },
      { className: 'key--letter', code: 'Digit6', character: '&#54;' },
      { className: 'key--letter', code: 'Digit7', character: '&#55;' },
      { className: 'key--letter', code: 'Digit8', character: '&#56;' },
      { className: 'key--letter', code: 'Digit9', character: '&#57;' },
      { className: 'key--letter', code: 'Digit0', character: '&#214;' },
      { className: 'key--letter', code: 'Minus', character: '&#47;' },
      { className: 'key--letter', code: 'Equal', character: '&#176;' },
      {
        className: 'key--bottom-right key--word key--w2',
        code: 'Backspace',
        character: '<span>backspace</span>',
      },
    ],
    row2: [
      {
        className: 'key--bottom-left key--word key--w2',
        code: 'Tab',
        character: '<span>menu up</span>',
      },
      { className: 'key--letter', code: 'KeyQ', character: '&#81;' },
      { className: 'key--letter', code: 'KeyW', character: '&#87;' },
      { className: 'key--letter', code: 'KeyE', character: '&#69;' },
      { className: 'key--letter', code: 'KeyR', character: '&#82;' },
      { className: 'key--letter', code: 'KeyT', character: '&#84;' },
      { className: 'key--letter', code: 'KeyY', character: '&#89;' },
      { className: 'key--letter', code: 'KeyU', character: '&#85;' },
      { className: 'key--letter', code: 'KeyI', character: '&#73;' },
      { className: 'key--letter', code: 'KeyO', character: '&#79;' },
      { className: 'key--letter', code: 'KeyP', character: '&#80;' },
      { className: 'key--letter', code: 'BracketLeft', character: '&#168;' },
      { className: 'key--letter', code: 'BracketRight', character: '&#42;' },
      { className: 'key--letter', code: 'IntlBackslash', character: '&#93;' },
    ],
    row3: [
      {
        className: 'key--bottom-left key--word key--w3',
        code: 'CapsLock',
        character: '<span>caps lock</span>',
      },
      { className: 'key--letter', code: 'KeyA', character: '&#65;' },
      { className: 'key--letter', code: 'KeyS', character: '&#83;' },
      { className: 'key--letter', code: 'KeyD', character: '&#68;' },
      { className: 'key--letter', code: 'KeyF', character: '&#70;' },
      { className: 'key--letter', code: 'KeyG', character: '&#71;' },
      { className: 'key--letter', code: 'KeyH', character: '&#72;' },
      { className: 'key--letter', code: 'KeyJ', character: '&#74;' },
      { className: 'key--letter', code: 'KeyK', character: '&#75;' },
      { className: 'key--letter', code: 'KeyL', character: '&#76;' },
      { className: 'key--letter', code: 'Semicolon', character: '&#43;' },
      { className: 'key--letter', code: 'Quote', character: '&#180;' },
      {
        className: 'key--bottom-right key--word key--w3',
        code: 'Enter',
        character: '<span>return</span>',
      },
    ],
    row4: scandinavianRow4,
    row5: [
      {
        className: 'key--bottom-left key--word key--w1',
        code: 'ControlLeft',
        character: '<span>ctrl</span>',
      },
      { className: 'key--bottom-left key--word', code: 'X1', character: '<span>fn</span>' },
      { className: 'key--bottom-left key--word', code: 'X2', character: '<span>option</span>' },
      {
        className: 'key--bottom-left key--word key--w1',
        code: 'AltLeft',
        character: '<span>alt</span>',
      },
      { className: 'key--w5', code: 'Space', character: '&nbsp;' },
      {
        className: 'key--bottom-right key--word',
        code: 'AltRight',
        character: '<span>alt gr</span>',
      },
      {
        className: 'key--bottom-right key--word',
        code: 'ControlRight',
        character: '<span>ctrl</span>',
      },
      { className: 'key--arrow', code: 'Y1', character: '&nbsp;' },
      { className: 'key--arrow--tall', code: 'X3', character: '&nbsp;' },
      { className: 'key--arrow', code: 'Y2', character: '&nbsp;' },
    ],
  },
  [ELanguage.Afrikaans]: englishAllKeys,
  [ELanguage.Russian]: {
    row1: [
      { className: 'key--letter', code: 'Backquote', character: '&#1025;' },
      { className: 'key--letter', code: 'Digit1', character: '&#49;' },
      { className: 'key--letter', code: 'Digit2', character: '&#50;' },
      { className: 'key--letter', code: 'Digit3', character: '&#51;' },
      { className: 'key--letter', code: 'Digit4', character: '&#52;' },
      { className: 'key--letter', code: 'Digit5', character: '&#53;' },
      { className: 'key--letter', code: 'Digit6', character: '&#54;' },
      { className: 'key--letter', code: 'Digit7', character: '&#55;' },
      { className: 'key--letter', code: 'Digit8', character: '&#56;' },
      { className: 'key--letter', code: 'Digit9', character: '&#57;' },
      { className: 'key--letter', code: 'Digit0', character: '&#48;' },
      { className: 'key--letter', code: 'Minus', character: '&#45;' },
      { className: 'key--letter', code: 'Equal', character: '&#61;' },
      {
        className: 'key--bottom-right key--word key--w2',
        code: 'Backspace',
        character: '<span>backspace</span>',
      },
    ],
    row2: [
      {
        className: 'key--bottom-left key--word key--w2',
        code: 'Tab',
        character: '<span>menu up</span>',
      },
      { className: 'key--letter', code: 'KeyQ', character: '&#1049;' },
      { className: 'key--letter', code: 'KeyW', character: '&#1062;' },
      { className: 'key--letter', code: 'KeyE', character: '&#1059;' },
      { className: 'key--letter', code: 'KeyR', character: '&#1050;' },
      { className: 'key--letter', code: 'KeyT', character: '&#1045;' },
      { className: 'key--letter', code: 'KeyY', character: '&#1053;' },
      { className: 'key--letter', code: 'KeyU', character: '&#1043;' },
      { className: 'key--letter', code: 'KeyI', character: '&#1064;' },
      { className: 'key--letter', code: 'KeyO', character: '&#1065;' },
      { className: 'key--letter', code: 'KeyP', character: '&#1047;' },
      { className: 'key--letter', code: 'BracketLeft', character: '&#1061;' },
      { className: 'key--letter', code: 'BracketRight', character: '&#1066;' },
      { className: 'key--letter', code: 'IntlBackslash', character: '&#92;' },
    ],
    row3: [
      {
        className: 'key--bottom-left key--word key--w3',
        code: 'CapsLock',
        character: '<span>caps lock</span>',
      },
      { className: 'key--letter', code: 'KeyA', character: '&#1060;' },
      { className: 'key--letter', code: 'KeyS', character: '&#1067;' },
      { className: 'key--letter', code: 'KeyD', character: '&#1042;' },
      { className: 'key--letter', code: 'KeyF', character: '&#1040;' },
      { className: 'key--letter', code: 'KeyG', character: '&#1055;' },
      { className: 'key--letter', code: 'KeyH', character: '&#1056;' },
      { className: 'key--letter', code: 'KeyJ', character: '&#1054;' },
      { className: 'key--letter', code: 'KeyK', character: '&#1051;' },
      { className: 'key--letter', code: 'KeyL', character: '&#1044;' },
      { className: 'key--letter', code: 'Semicolon', character: '&#1046;' },
      { className: 'key--letter', code: 'Quote', character: '&#1069;' },
      {
        className: 'key--bottom-right key--word key--w3',
        code: 'Enter',
        character: '<span>return</span>',
      },
    ],
    row4: [
      {
        className: 'key--bottom-left key--word key--w4',
        code: 'ShiftLeft',
        character: '<span>shift</span>',
      },
      { className: 'key--letter', code: 'KeyZ', character: '&#1071;' },
      { className: 'key--letter', code: 'KeyX', character: '&#1063;' },
      { className: 'key--letter', code: 'KeyC', character: '&#1057;' },
      { className: 'key--letter', code: 'KeyV', character: '&#1052;' },
      { className: 'key--letter', code: 'KeyB', character: '&#1048;' },
      { className: 'key--letter', code: 'KeyN', character: '&#1058;' },
      { className: 'key--letter', code: 'KeyM', character: '&#1068;' },
      { className: 'key--letter', code: 'Comma', character: '&#1041;' },
      { className: 'key--letter', code: 'Period', character: '&#1070;' },
      { className: 'key--letter', code: 'Slash', character: '&#46;' },
      {
        className: 'key--bottom-right key--word key--w4',
        code: 'ShiftRight',
        character: '<span>shift</span>',
      },
    ],
    row5: [
      {
        className: 'key--bottom-left key--word key--w1',
        code: 'ControlLeft',
        character: '<span>ctrl</span>',
      },
      { className: 'key--bottom-left key--word', code: 'X1', character: '<span>fn</span>' },
      { className: 'key--bottom-left key--word', code: 'X2', character: '<span>option</span>' },
      {
        className: 'key--bottom-left key--word key--w1',
        code: 'AltLeft',
        character: '<span>alt</span>',
      },
      { className: 'key--w5', code: 'Space', character: '&nbsp;' },
      {
        className: 'key--bottom-right key--word',
        code: 'AltRight',
        character: '<span>alt gr</span>',
      },
      {
        className: 'key--bottom-right key--word',
        code: 'ControlRight',
        character: '<span>ctrl</span>',
      },
      { className: 'key--arrow', code: 'Y1', character: '&nbsp;' },
      { className: 'key--arrow--tall', code: 'X3', character: '&nbsp;' },
      { className: 'key--arrow', code: 'Y2', character: '&nbsp;' },
    ],
  },
  [ELanguage.Latvian]: englishAllKeys,
  [ELanguage.Polish]: {
    row1: [
      { className: 'key--letter', code: 'Backquote', character: '&#731;' },
      { className: 'key--letter', code: 'Digit1', character: '&#49;' },
      { className: 'key--letter', code: 'Digit2', character: '&#50;' },
      { className: 'key--letter', code: 'Digit3', character: '&#51;' },
      { className: 'key--letter', code: 'Digit4', character: '&#52;' },
      { className: 'key--letter', code: 'Digit5', character: '&#53;' },
      { className: 'key--letter', code: 'Digit6', character: '&#54;' },
      { className: 'key--letter', code: 'Digit7', character: '&#55;' },
      { className: 'key--letter', code: 'Digit8', character: '&#56;' },
      { className: 'key--letter', code: 'Digit9', character: '&#57;' },
      { className: 'key--letter', code: 'Digit0', character: '&#48;' },
      { className: 'key--letter', code: 'Minus', character: '&#43;' },
      { className: 'key--letter', code: 'Equal', character: '&#39;' },
      {
        className: 'key--bottom-right key--word key--w2',
        code: 'Backspace',
        character: '<span>backspace</span>',
      },
    ],
    row2: [
      {
        className: 'key--bottom-left key--word key--w2',
        code: 'Tab',
        character: '<span>menu up</span>',
      },
      { className: 'key--letter', code: 'KeyQ', character: '&#81;' },
      { className: 'key--letter', code: 'KeyW', character: '&#87;' },
      { className: 'key--letter', code: 'KeyE', character: '&#69;' },
      { className: 'key--letter', code: 'KeyR', character: '&#82;' },
      { className: 'key--letter', code: 'KeyT', character: '&#84;' },
      { className: 'key--letter', code: 'KeyY', character: '&#90;' },
      { className: 'key--letter', code: 'KeyU', character: '&#85;' },
      { className: 'key--letter', code: 'KeyI', character: '&#73;' },
      { className: 'key--letter', code: 'KeyO', character: '&#79;' },
      { className: 'key--letter', code: 'KeyP', character: '&#80;' },
      { className: 'key--letter', code: 'BracketLeft', character: '&#380;' },
      { className: 'key--letter', code: 'BracketRight', character: '&#346;' },
      { className: 'key--letter', code: 'IntlBackslash', character: '&#60;' },
    ],
    row3: [
      {
        className: 'key--bottom-left key--word key--w3',
        code: 'CapsLock',
        character: '<span>caps lock</span>',
      },
      { className: 'key--letter', code: 'KeyA', character: '&#65;' },
      { className: 'key--letter', code: 'KeyS', character: '&#83;' },
      { className: 'key--letter', code: 'KeyD', character: '&#68;' },
      { className: 'key--letter', code: 'KeyF', character: '&#70;' },
      { className: 'key--letter', code: 'KeyG', character: '&#71;' },
      { className: 'key--letter', code: 'KeyH', character: '&#72;' },
      { className: 'key--letter', code: 'KeyJ', character: '&#74;' },
      { className: 'key--letter', code: 'KeyK', character: '&#75;' },
      { className: 'key--letter', code: 'KeyL', character: '&#76;' },
      { className: 'key--letter', code: 'Semicolon', character: '&#322;' },
      { className: 'key--letter', code: 'Quote', character: '&#260;' },
      {
        className: 'key--bottom-right key--word key--w3',
        code: 'Enter',
        character: '<span>return</span>',
      },
    ],
    row4: austroHungarianRow4,
    row5: [
      {
        className: 'key--bottom-left key--word key--w1',
        code: 'ControlLeft',
        character: '<span>ctrl</span>',
      },
      { className: 'key--bottom-left key--word', code: 'X1', character: '<span>fn</span>' },
      { className: 'key--bottom-left key--word', code: 'X2', character: '<span>option</span>' },
      {
        className: 'key--bottom-left key--word key--w1',
        code: 'AltLeft',
        character: '<span>alt</span>',
      },
      { className: 'key--w5', code: 'Space', character: '&nbsp;' },
      {
        className: 'key--bottom-right key--word',
        code: 'AltRight',
        character: '<span>alt gr</span>',
      },
      {
        className: 'key--bottom-right key--word',
        code: 'ControlRight',
        character: '<span>ctrl</span>',
      },
      { className: 'key--arrow', code: 'Y1', character: '&nbsp;' },
      { className: 'key--arrow--tall', code: 'X3', character: '&nbsp;' },
      { className: 'key--arrow', code: 'Y2', character: '&nbsp;' },
    ],
  },
  [ELanguage.French]: {
    row1: [
      { className: 'key--letter', code: 'Backquote', character: '&#178;' },
      { className: 'key--letter', code: 'Digit1', character: '&#38;' },
      { className: 'key--letter', code: 'Digit2', character: '&#233;' },
      { className: 'key--letter', code: 'Digit3', character: '&#34;' },
      { className: 'key--letter', code: 'Digit4', character: '&#39;' },
      { className: 'key--letter', code: 'Digit5', character: '&#40;' },
      { className: 'key--letter', code: 'Digit6', character: '&#45;' },
      { className: 'key--letter', code: 'Digit7', character: '&#232;' },
      { className: 'key--letter', code: 'Digit8', character: '&#175;' },
      { className: 'key--letter', code: 'Digit9', character: '&#231;' },
      { className: 'key--letter', code: 'Digit0', character: '&#224;' },
      { className: 'key--letter', code: 'Minus', character: '&#41;' },
      { className: 'key--letter', code: 'Equal', character: '&#39;' },
      {
        className: 'key--bottom-right key--word key--w2',
        code: 'Backspace',
        character: '<span>backspace</span>',
      },
    ],
    row2: [
      {
        className: 'key--bottom-left key--word key--w2',
        code: 'Tab',
        character: '<span>menu up</span>',
      },
      { className: 'key--letter', code: 'KeyQ', character: '&#65;' },
      { className: 'key--letter', code: 'KeyW', character: '&#90;' },
      { className: 'key--letter', code: 'KeyE', character: '&#69;' },
      { className: 'key--letter', code: 'KeyR', character: '&#82;' },
      { className: 'key--letter', code: 'KeyT', character: '&#84;' },
      { className: 'key--letter', code: 'KeyY', character: '&#90;' },
      { className: 'key--letter', code: 'KeyU', character: '&#85;' },
      { className: 'key--letter', code: 'KeyI', character: '&#73;' },
      { className: 'key--letter', code: 'KeyO', character: '&#79;' },
      { className: 'key--letter', code: 'KeyP', character: '&#80;' },
      { className: 'key--letter', code: 'BracketLeft', character: '&#94;' },
      { className: 'key--letter', code: 'BracketRight', character: '&#36;' },
      { className: 'key--letter', code: 'IntlBackslash', character: '&#60;' },
    ],
    row3: [
      {
        className: 'key--bottom-left key--word key--w3',
        code: 'CapsLock',
        character: '<span>caps lock</span>',
      },
      { className: 'key--letter', code: 'KeyA', character: '&#81;' },
      { className: 'key--letter', code: 'KeyS', character: '&#83;' },
      { className: 'key--letter', code: 'KeyD', character: '&#68;' },
      { className: 'key--letter', code: 'KeyF', character: '&#70;' },
      { className: 'key--letter', code: 'KeyG', character: '&#71;' },
      { className: 'key--letter', code: 'KeyH', character: '&#72;' },
      { className: 'key--letter', code: 'KeyJ', character: '&#74;' },
      { className: 'key--letter', code: 'KeyK', character: '&#75;' },
      { className: 'key--letter', code: 'KeyL', character: '&#76;' },
      { className: 'key--letter', code: 'Semicolon', character: '&#77;' },
      { className: 'key--letter', code: 'Quote', character: '&#249;' },
      {
        className: 'key--bottom-right key--word key--w3',
        code: 'Enter',
        character: '<span>return</span>',
      },
    ],
    row4: [
      {
        className: 'key--bottom-left key--word key--w4',
        code: 'ShiftLeft',
        character: '<span>shift</span>',
      },
      { className: 'key--letter', code: 'KeyZ', character: '&#87;' },
      { className: 'key--letter', code: 'KeyX', character: '&#88;' },
      { className: 'key--letter', code: 'KeyC', character: '&#67;' },
      { className: 'key--letter', code: 'KeyV', character: '&#86;' },
      { className: 'key--letter', code: 'KeyB', character: '&#66;' },
      { className: 'key--letter', code: 'KeyN', character: '&#78;' },
      { className: 'key--letter', code: 'KeyM', character: '&#44;' },
      { className: 'key--letter', code: 'Comma', character: '&#59;' },
      { className: 'key--letter', code: 'Period', character: '&#58;' },
      { className: 'key--letter', code: 'Slash', character: '&#33;' },
      {
        className: 'key--bottom-right key--word key--w4',
        code: 'ShiftRight',
        character: '<span>shift</span>',
      },
    ],
    row5: [
      {
        className: 'key--bottom-left key--word key--w1',
        code: 'ControlLeft',
        character: '<span>ctrl</span>',
      },
      { className: 'key--bottom-left key--word', code: 'X1', character: '<span>fn</span>' },
      { className: 'key--bottom-left key--word', code: 'X2', character: '<span>option</span>' },
      {
        className: 'key--bottom-left key--word key--w1',
        code: 'AltLeft',
        character: '<span>alt</span>',
      },
      { className: 'key--w5', code: 'Space', character: '&nbsp;' },
      {
        className: 'key--bottom-right key--word',
        code: 'AltRight',
        character: '<span>alt gr</span>',
      },
      {
        className: 'key--bottom-right key--word',
        code: 'ControlRight',
        character: '<span>ctrl</span>',
      },
      { className: 'key--arrow', code: 'Y1', character: '&nbsp;' },
      { className: 'key--arrow--tall', code: 'X3', character: '&nbsp;' },
      { className: 'key--arrow', code: 'Y2', character: '&nbsp;' },
    ],
  },
  [ELanguage.Spanish]: {
    row1: [
      { className: 'key--letter', code: 'Backquote', character: '&#176;' },
      { className: 'key--letter', code: 'Digit1', character: '&#38;' },
      { className: 'key--letter', code: 'Digit2', character: '&#233;' },
      { className: 'key--letter', code: 'Digit3', character: '&#34;' },
      { className: 'key--letter', code: 'Digit4', character: '&#39;' },
      { className: 'key--letter', code: 'Digit5', character: '&#40;' },
      { className: 'key--letter', code: 'Digit6', character: '&#45;' },
      { className: 'key--letter', code: 'Digit7', character: '&#232;' },
      { className: 'key--letter', code: 'Digit8', character: '&#175;' },
      { className: 'key--letter', code: 'Digit9', character: '&#231;' },
      { className: 'key--letter', code: 'Digit0', character: '&#224;' },
      { className: 'key--letter', code: 'Minus', character: '&#39;' },
      { className: 'key--letter', code: 'Equal', character: '&#161;' },
      {
        className: 'key--bottom-right key--word key--w2',
        code: 'Backspace',
        character: '<span>backspace</span>',
      },
    ],
    row2: [
      {
        className: 'key--bottom-left key--word key--w2',
        code: 'Tab',
        character: '<span>menu up</span>',
      },
      { className: 'key--letter', code: 'KeyQ', character: '&#65;' },
      { className: 'key--letter', code: 'KeyW', character: '&#90;' },
      { className: 'key--letter', code: 'KeyE', character: '&#69;' },
      { className: 'key--letter', code: 'KeyR', character: '&#82;' },
      { className: 'key--letter', code: 'KeyT', character: '&#84;' },
      { className: 'key--letter', code: 'KeyY', character: '&#90;' },
      { className: 'key--letter', code: 'KeyU', character: '&#85;' },
      { className: 'key--letter', code: 'KeyI', character: '&#73;' },
      { className: 'key--letter', code: 'KeyO', character: '&#79;' },
      { className: 'key--letter', code: 'KeyP', character: '&#80;' },
      { className: 'key--letter', code: 'BracketLeft', character: '&#96;' },
      { className: 'key--letter', code: 'BracketRight', character: '&#43;' },
      { className: 'key--letter', code: 'IntlBackslash', character: '&#60;' },
    ],
    row3: [
      {
        className: 'key--bottom-left key--word key--w3',
        code: 'CapsLock',
        character: '<span>caps lock</span>',
      },
      { className: 'key--letter', code: 'KeyA', character: '&#81;' },
      { className: 'key--letter', code: 'KeyS', character: '&#83;' },
      { className: 'key--letter', code: 'KeyD', character: '&#68;' },
      { className: 'key--letter', code: 'KeyF', character: '&#70;' },
      { className: 'key--letter', code: 'KeyG', character: '&#71;' },
      { className: 'key--letter', code: 'KeyH', character: '&#72;' },
      { className: 'key--letter', code: 'KeyJ', character: '&#74;' },
      { className: 'key--letter', code: 'KeyK', character: '&#75;' },
      { className: 'key--letter', code: 'KeyL', character: '&#76;' },
      { className: 'key--letter', code: 'Semicolon', character: '&#209;' },
      { className: 'key--letter', code: 'Quote', character: '&#180;' },
      {
        className: 'key--bottom-right key--word key--w3',
        code: 'Enter',
        character: '<span>return</span>',
      },
    ],
    row4: [
      {
        className: 'key--bottom-left key--word key--w4',
        code: 'ShiftLeft',
        character: '<span>shift</span>',
      },
      { className: 'key--letter', code: 'KeyZ', character: '&#87;' },
      { className: 'key--letter', code: 'KeyX', character: '&#88;' },
      { className: 'key--letter', code: 'KeyC', character: '&#67;' },
      { className: 'key--letter', code: 'KeyV', character: '&#86;' },
      { className: 'key--letter', code: 'KeyB', character: '&#66;' },
      { className: 'key--letter', code: 'KeyN', character: '&#78;' },
      { className: 'key--letter', code: 'KeyM', character: '&#44;' },
      { className: 'key--letter', code: 'Comma', character: '&#59;' },
      { className: 'key--letter', code: 'Period', character: '&#58;' },
      { className: 'key--letter', code: 'Slash', character: '&#45;' },
      {
        className: 'key--bottom-right key--word key--w4',
        code: 'ShiftRight',
        character: '<span>shift</span>',
      },
    ],
    row5: [
      {
        className: 'key--bottom-left key--word key--w1',
        code: 'ControlLeft',
        character: '<span>ctrl</span>',
      },
      { className: 'key--bottom-left key--word', code: 'X1', character: '<span>fn</span>' },
      { className: 'key--bottom-left key--word', code: 'X2', character: '<span>option</span>' },
      {
        className: 'key--bottom-left key--word key--w1',
        code: 'AltLeft',
        character: '<span>alt</span>',
      },
      { className: 'key--w5', code: 'Space', character: '&nbsp;' },
      {
        className: 'key--bottom-right key--word',
        code: 'AltRight',
        character: '<span>alt gr</span>',
      },
      {
        className: 'key--bottom-right key--word',
        code: 'ControlRight',
        character: '<span>ctrl</span>',
      },
      { className: 'key--arrow', code: 'Y1', character: '&nbsp;' },
      { className: 'key--arrow--tall', code: 'X3', character: '&nbsp;' },
      { className: 'key--arrow', code: 'Y2', character: '&nbsp;' },
    ],
  },
};

export type TSpecialKeyRole =
  | 'backspace'
  | 'menuUp'
  | 'capsLock'
  | 'enter'
  | 'shift'
  | 'ctrl'
  | 'fn'
  | 'option'
  | 'alt'
  | 'altGr'
  | 'clearAll';

export const specialKeyLabels: Record<TSpecialKeyRole, Record<ELanguage, string>> = {
  backspace: {
    [ELanguage.English]: 'backspace',
    [ELanguage.Swedish]: 'backsteg',
    [ELanguage.Norwegian]: 'tilbaketast',
    [ELanguage.Finnish]: 'askelpalautin',
    [ELanguage.Hungarian]: 'törlés',
    [ELanguage.German]: 'rücktaste',
    [ELanguage.Dutch]: 'backspace',
    [ELanguage.Afrikaans]: 'trusleutel',
    [ELanguage.Russian]: 'забой',
    [ELanguage.Latvian]: 'atpakaļatkāpe',
    [ELanguage.Polish]: 'backspace',
    [ELanguage.French]: 'retour arrière',
    [ELanguage.Spanish]: 'retroceso',
  },
  menuUp: {
    [ELanguage.English]: 'menu up',
    [ELanguage.Swedish]: 'meny upp',
    [ELanguage.Norwegian]: 'meny opp',
    [ELanguage.Finnish]: 'valikko ylös',
    [ELanguage.Hungarian]: 'menü fel',
    [ELanguage.German]: 'menü hoch',
    [ELanguage.Dutch]: 'menu omhoog',
    [ELanguage.Afrikaans]: 'kieslys op',
    [ELanguage.Russian]: 'меню вверх',
    [ELanguage.Latvian]: 'izvēlne augšup',
    [ELanguage.Polish]: 'menu w górę',
    [ELanguage.French]: 'menu haut',
    [ELanguage.Spanish]: 'menú arriba',
  },
  capsLock: {
    [ELanguage.English]: 'caps lock',
    [ELanguage.Swedish]: 'caps lock',
    [ELanguage.Norwegian]: 'caps lock',
    [ELanguage.Finnish]: 'caps lock',
    [ELanguage.Hungarian]: 'caps lock',
    [ELanguage.German]: 'feststelltaste',
    [ELanguage.Dutch]: 'caps lock',
    [ELanguage.Afrikaans]: 'caps lock',
    [ELanguage.Russian]: 'caps lock',
    [ELanguage.Latvian]: 'caps lock',
    [ELanguage.Polish]: 'caps lock',
    [ELanguage.French]: 'verr maj',
    [ELanguage.Spanish]: 'bloq mayús',
  },
  enter: {
    [ELanguage.English]: 'return',
    [ELanguage.Swedish]: 'retur',
    [ELanguage.Norwegian]: 'retur',
    [ELanguage.Finnish]: 'enter',
    [ELanguage.Hungarian]: 'enter',
    [ELanguage.German]: 'eingabe',
    [ELanguage.Dutch]: 'enter',
    [ELanguage.Afrikaans]: 'enter',
    [ELanguage.Russian]: 'ввод',
    [ELanguage.Latvian]: 'ievadīt',
    [ELanguage.Polish]: 'enter',
    [ELanguage.French]: 'entrée',
    [ELanguage.Spanish]: 'intro',
  },
  shift: {
    [ELanguage.English]: 'shift',
    [ELanguage.Swedish]: 'skift',
    [ELanguage.Norwegian]: 'shift',
    [ELanguage.Finnish]: 'vaihto',
    [ELanguage.Hungarian]: 'shift',
    [ELanguage.German]: 'umschalt',
    [ELanguage.Dutch]: 'shift',
    [ELanguage.Afrikaans]: 'skuif',
    [ELanguage.Russian]: 'shift',
    [ELanguage.Latvian]: 'shift',
    [ELanguage.Polish]: 'shift',
    [ELanguage.French]: 'maj',
    [ELanguage.Spanish]: 'mayús',
  },
  ctrl: {
    [ELanguage.English]: 'ctrl',
    [ELanguage.Swedish]: 'ctrl',
    [ELanguage.Norwegian]: 'ctrl',
    [ELanguage.Finnish]: 'ctrl',
    [ELanguage.Hungarian]: 'ctrl',
    [ELanguage.German]: 'strg',
    [ELanguage.Dutch]: 'ctrl',
    [ELanguage.Afrikaans]: 'ctrl',
    [ELanguage.Russian]: 'ctrl',
    [ELanguage.Latvian]: 'ctrl',
    [ELanguage.Polish]: 'ctrl',
    [ELanguage.French]: 'ctrl',
    [ELanguage.Spanish]: 'ctrl',
  },
  fn: {
    [ELanguage.English]: 'fn',
    [ELanguage.Swedish]: 'fn',
    [ELanguage.Norwegian]: 'fn',
    [ELanguage.Finnish]: 'fn',
    [ELanguage.Hungarian]: 'fn',
    [ELanguage.German]: 'fn',
    [ELanguage.Dutch]: 'fn',
    [ELanguage.Afrikaans]: 'fn',
    [ELanguage.Russian]: 'fn',
    [ELanguage.Latvian]: 'fn',
    [ELanguage.Polish]: 'fn',
    [ELanguage.French]: 'fn',
    [ELanguage.Spanish]: 'fn',
  },
  option: {
    [ELanguage.English]: 'option',
    [ELanguage.Swedish]: 'alternativ',
    [ELanguage.Norwegian]: 'alternativ',
    [ELanguage.Finnish]: 'optio',
    [ELanguage.Hungarian]: 'opció',
    [ELanguage.German]: 'option',
    [ELanguage.Dutch]: 'optie',
    [ELanguage.Afrikaans]: 'opsie',
    [ELanguage.Russian]: 'опция',
    [ELanguage.Latvian]: 'opcija',
    [ELanguage.Polish]: 'opcja',
    [ELanguage.French]: 'option',
    [ELanguage.Spanish]: 'opción',
  },
  alt: {
    [ELanguage.English]: 'alt',
    [ELanguage.Swedish]: 'alt',
    [ELanguage.Norwegian]: 'alt',
    [ELanguage.Finnish]: 'alt',
    [ELanguage.Hungarian]: 'alt',
    [ELanguage.German]: 'alt',
    [ELanguage.Dutch]: 'alt',
    [ELanguage.Afrikaans]: 'alt',
    [ELanguage.Russian]: 'alt',
    [ELanguage.Latvian]: 'alt',
    [ELanguage.Polish]: 'alt',
    [ELanguage.French]: 'alt',
    [ELanguage.Spanish]: 'alt',
  },
  altGr: {
    [ELanguage.English]: 'alt gr',
    [ELanguage.Swedish]: 'alt gr',
    [ELanguage.Norwegian]: 'alt gr',
    [ELanguage.Finnish]: 'alt gr',
    [ELanguage.Hungarian]: 'alt gr',
    [ELanguage.German]: 'alt gr',
    [ELanguage.Dutch]: 'alt gr',
    [ELanguage.Afrikaans]: 'alt gr',
    [ELanguage.Russian]: 'alt gr',
    [ELanguage.Latvian]: 'alt gr',
    [ELanguage.Polish]: 'alt gr',
    [ELanguage.French]: 'alt gr',
    [ELanguage.Spanish]: 'alt gr',
  },
  clearAll: {
    [ELanguage.English]: 'clear all',
    [ELanguage.Swedish]: 'rensa allt',
    [ELanguage.Norwegian]: 'fjern alt',
    [ELanguage.Finnish]: 'tyhjennä kaikki',
    [ELanguage.Hungarian]: 'összes törlése',
    [ELanguage.German]: 'alles löschen',
    [ELanguage.Dutch]: 'alles wissen',
    [ELanguage.Afrikaans]: 'maak alles skoon',
    [ELanguage.Russian]: 'очистить всё',
    [ELanguage.Latvian]: 'notīrīt visu',
    [ELanguage.Polish]: 'wyczyść wszystko',
    [ELanguage.French]: 'tout effacer',
    [ELanguage.Spanish]: 'borrar todo',
  },
};

export const specialKeyRoleByCode: Record<string, TSpecialKeyRole> = {
  Backspace: 'backspace',
  Tab: 'menuUp',
  CapsLock: 'capsLock',
  Enter: 'enter',
  ShiftLeft: 'shift',
  ShiftRight: 'shift',
  ControlLeft: 'ctrl',
  ControlRight: 'ctrl',
  X1: 'fn',
  X2: 'option',
  AltLeft: 'alt',
  AltRight: 'altGr',
};

export const languageNames: Record<ELanguage, Record<ELanguage, string>> = {
  [ELanguage.English]: {
    [ELanguage.English]: 'English',
    [ELanguage.Swedish]: 'Engelska',
    [ELanguage.Norwegian]: 'Engelsk',
    [ELanguage.Finnish]: 'Englanti',
    [ELanguage.Hungarian]: 'Angol',
    [ELanguage.German]: 'Englisch',
    [ELanguage.Dutch]: 'Engels',
    [ELanguage.Afrikaans]: 'Engels',
    [ELanguage.Russian]: 'Английский',
    [ELanguage.Latvian]: 'Angļu',
    [ELanguage.Polish]: 'Angielski',
    [ELanguage.French]: 'Anglais',
    [ELanguage.Spanish]: 'Inglés',
  },
  [ELanguage.Swedish]: {
    [ELanguage.English]: 'Swedish',
    [ELanguage.Swedish]: 'Svenska',
    [ELanguage.Norwegian]: 'Svensk',
    [ELanguage.Finnish]: 'Ruotsi',
    [ELanguage.Hungarian]: 'Svéd',
    [ELanguage.German]: 'Schwedisch',
    [ELanguage.Dutch]: 'Zweeds',
    [ELanguage.Afrikaans]: 'Sweeds',
    [ELanguage.Russian]: 'Шведский',
    [ELanguage.Latvian]: 'Zviedru',
    [ELanguage.Polish]: 'Szwedzki',
    [ELanguage.French]: 'Suédois',
    [ELanguage.Spanish]: 'Sueco',
  },
  [ELanguage.Norwegian]: {
    [ELanguage.English]: 'Norwegian',
    [ELanguage.Swedish]: 'Norska',
    [ELanguage.Norwegian]: 'Norsk',
    [ELanguage.Finnish]: 'Norja',
    [ELanguage.Hungarian]: 'Norvég',
    [ELanguage.German]: 'Norwegisch',
    [ELanguage.Dutch]: 'Noors',
    [ELanguage.Afrikaans]: 'Noors',
    [ELanguage.Russian]: 'Норвежский',
    [ELanguage.Latvian]: 'Norvēģu',
    [ELanguage.Polish]: 'Norweski',
    [ELanguage.French]: 'Norvégien',
    [ELanguage.Spanish]: 'Noruego',
  },
  [ELanguage.Finnish]: {
    [ELanguage.English]: 'Finnish',
    [ELanguage.Swedish]: 'Finska',
    [ELanguage.Norwegian]: 'Finsk',
    [ELanguage.Finnish]: 'Suomi',
    [ELanguage.Hungarian]: 'Finn',
    [ELanguage.German]: 'Finnisch',
    [ELanguage.Dutch]: 'Fins',
    [ELanguage.Afrikaans]: 'Fins',
    [ELanguage.Russian]: 'Финский',
    [ELanguage.Latvian]: 'Somu',
    [ELanguage.Polish]: 'Fiński',
    [ELanguage.French]: 'Finnois',
    [ELanguage.Spanish]: 'Finés',
  },
  [ELanguage.Hungarian]: {
    [ELanguage.English]: 'Hungarian',
    [ELanguage.Swedish]: 'Ungerska',
    [ELanguage.Norwegian]: 'Ungarsk',
    [ELanguage.Finnish]: 'Unkari',
    [ELanguage.Hungarian]: 'Magyar',
    [ELanguage.German]: 'Ungarisch',
    [ELanguage.Dutch]: 'Hongaars',
    [ELanguage.Afrikaans]: 'Hongaars',
    [ELanguage.Russian]: 'Венгерский',
    [ELanguage.Latvian]: 'Ungāru',
    [ELanguage.Polish]: 'Węgierski',
    [ELanguage.French]: 'Hongrois',
    [ELanguage.Spanish]: 'Húngaro',
  },
  [ELanguage.German]: {
    [ELanguage.English]: 'German',
    [ELanguage.Swedish]: 'Tyska',
    [ELanguage.Norwegian]: 'Tysk',
    [ELanguage.Finnish]: 'Saksa',
    [ELanguage.Hungarian]: 'Német',
    [ELanguage.German]: 'Deutsch',
    [ELanguage.Dutch]: 'Duits',
    [ELanguage.Afrikaans]: 'Duits',
    [ELanguage.Russian]: 'Немецкий',
    [ELanguage.Latvian]: 'Vācu',
    [ELanguage.Polish]: 'Niemiecki',
    [ELanguage.French]: 'Allemand',
    [ELanguage.Spanish]: 'Alemán',
  },
  [ELanguage.Dutch]: {
    [ELanguage.English]: 'Dutch',
    [ELanguage.Swedish]: 'Nederländska',
    [ELanguage.Norwegian]: 'Nederlandsk',
    [ELanguage.Finnish]: 'Hollanti',
    [ELanguage.Hungarian]: 'Holland',
    [ELanguage.German]: 'Niederländisch',
    [ELanguage.Dutch]: 'Nederlands',
    [ELanguage.Afrikaans]: 'Nederlands',
    [ELanguage.Russian]: 'Голландский',
    [ELanguage.Latvian]: 'Holandiešu',
    [ELanguage.Polish]: 'Niderlandzki',
    [ELanguage.French]: 'Néerlandais',
    [ELanguage.Spanish]: 'Neerlandés',
  },
  [ELanguage.Afrikaans]: {
    [ELanguage.English]: 'Afrikaans',
    [ELanguage.Swedish]: 'Afrikaans',
    [ELanguage.Norwegian]: 'Afrikaans',
    [ELanguage.Finnish]: 'Afrikaans',
    [ELanguage.Hungarian]: 'Afrikaans',
    [ELanguage.German]: 'Afrikaans',
    [ELanguage.Dutch]: 'Afrikaans',
    [ELanguage.Afrikaans]: 'Afrikaans',
    [ELanguage.Russian]: 'Африкаанс',
    [ELanguage.Latvian]: 'Āfrikāndu',
    [ELanguage.Polish]: 'Afrikaans',
    [ELanguage.French]: 'Afrikaans',
    [ELanguage.Spanish]: 'Afrikáans',
  },
  [ELanguage.Russian]: {
    [ELanguage.English]: 'Russian',
    [ELanguage.Swedish]: 'Ryska',
    [ELanguage.Norwegian]: 'Russisk',
    [ELanguage.Finnish]: 'Venäjä',
    [ELanguage.Hungarian]: 'Orosz',
    [ELanguage.German]: 'Russisch',
    [ELanguage.Dutch]: 'Russisch',
    [ELanguage.Afrikaans]: 'Russies',
    [ELanguage.Russian]: 'Русский',
    [ELanguage.Latvian]: 'Krievu',
    [ELanguage.Polish]: 'Rosyjski',
    [ELanguage.French]: 'Russe',
    [ELanguage.Spanish]: 'Ruso',
  },
  [ELanguage.Latvian]: {
    [ELanguage.English]: 'Latvian',
    [ELanguage.Swedish]: 'Lettiska',
    [ELanguage.Norwegian]: 'Latvisk',
    [ELanguage.Finnish]: 'Latvia',
    [ELanguage.Hungarian]: 'Lett',
    [ELanguage.German]: 'Lettisch',
    [ELanguage.Dutch]: 'Lets',
    [ELanguage.Afrikaans]: 'Lets',
    [ELanguage.Russian]: 'Латышский',
    [ELanguage.Latvian]: 'Latviešu',
    [ELanguage.Polish]: 'Łotewski',
    [ELanguage.French]: 'Letton',
    [ELanguage.Spanish]: 'Letón',
  },
  [ELanguage.Polish]: {
    [ELanguage.English]: 'Polish',
    [ELanguage.Swedish]: 'Polska',
    [ELanguage.Norwegian]: 'Polsk',
    [ELanguage.Finnish]: 'Puola',
    [ELanguage.Hungarian]: 'Lengyel',
    [ELanguage.German]: 'Polnisch',
    [ELanguage.Dutch]: 'Pools',
    [ELanguage.Afrikaans]: 'Pools',
    [ELanguage.Russian]: 'Польский',
    [ELanguage.Latvian]: 'Poļu',
    [ELanguage.Polish]: 'Polski',
    [ELanguage.French]: 'Polonais',
    [ELanguage.Spanish]: 'Polaco',
  },
  [ELanguage.French]: {
    [ELanguage.English]: 'French',
    [ELanguage.Swedish]: 'Franska',
    [ELanguage.Norwegian]: 'Fransk',
    [ELanguage.Finnish]: 'Ranska',
    [ELanguage.Hungarian]: 'Francia',
    [ELanguage.German]: 'Französisch',
    [ELanguage.Dutch]: 'Frans',
    [ELanguage.Afrikaans]: 'Frans',
    [ELanguage.Russian]: 'Французский',
    [ELanguage.Latvian]: 'Franču',
    [ELanguage.Polish]: 'Francuski',
    [ELanguage.French]: 'Français',
    [ELanguage.Spanish]: 'Francés',
  },
  [ELanguage.Spanish]: {
    [ELanguage.English]: 'Spanish',
    [ELanguage.Swedish]: 'Spanska',
    [ELanguage.Norwegian]: 'Spansk',
    [ELanguage.Finnish]: 'Espanja',
    [ELanguage.Hungarian]: 'Spanyol',
    [ELanguage.German]: 'Spanisch',
    [ELanguage.Dutch]: 'Spaans',
    [ELanguage.Afrikaans]: 'Spaans',
    [ELanguage.Russian]: 'Испанский',
    [ELanguage.Latvian]: 'Spāņu',
    [ELanguage.Polish]: 'Hiszpański',
    [ELanguage.French]: 'Espagnol',
    [ELanguage.Spanish]: 'Español',
  },
};
